import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

import {
  ModalBackground,
  MainWrapper,
  ChildrenWrapper,
  FooterWrapper,
  CloseCircleBlock,
} from './lightModal.styled';

const LightModal = props => {
  const { mobile, isOpen, onCloseBtnClick } = props;

  if (!isOpen) return null;

  return (
    <>
      <ModalBackground
        mobile={mobile}
        backgroundThemeColor={props.backgroundThemeColor}
        onClick={onCloseBtnClick}
      />
      <MainWrapper mobile={mobile}>
        <ChildrenWrapper>{props.children}</ChildrenWrapper>
        {!props.removeClose && (
          <FooterWrapper>
            <CloseCircleBlock onClick={onCloseBtnClick}>
              <Icon name='close' />
            </CloseCircleBlock>
          </FooterWrapper>
        )}
      </MainWrapper>
    </>
  );
};

LightModal.defaultProps = {
  isOpen: false,
  removeClose: false,
  onCloseBtnClick: () => {},
  backgroundThemeColor: ['wfBlack', 0.8],
};

LightModal.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.node,
  mobile: PropTypes.bool,
  removeClose: PropTypes.bool,
  onCloseBtnClick: PropTypes.func,
  backgroundThemeColor: PropTypes.array,
};

export default LightModal;

/*
  You can open the LightModal from everywhere if the component is render on the DOM:
  if (window.lightModal) window.lightModal.open();

  If you are on the CAD tool viewer.js you can pre select the content index with the default value of 0:
  if (this.viewerControl) {
    this.viewerControl.setLightModalContentIndex(1);
    this.viewerControl.toggleLightModalVisibility(true);
  }
*/
